import React, { useState } from "react";
import "./ReusableTable.css";
import Pagination from "../reusable-pagination/Pagination";

export interface Column<T> {
  header: string;
  accessor?: keyof T;
  render?: (row: T) => React.ReactNode;
}

interface ReusableTableProps<T> {
  columns: Column<T>[];
  rows: T[];
  itemsPerPage?: number;
}

function ReusableTable<T extends { id: number | string }>({
  columns,
  rows,
  itemsPerPage = 15,
}: ReusableTableProps<T>) {
  const [currentPage, setCurrentPage] = useState(1);
  const start = (currentPage - 1) * itemsPerPage;
  const pagedRows = rows.slice(start, start + itemsPerPage);
  const totalPages = Math.ceil(rows.length / itemsPerPage);

  return (
    <>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pagedRows.length ? (
              pagedRows.map((row) => (
                <tr key={row.id}>
                  {columns.map((col, index) => (
                    <td key={index}>
                      {col.render
                        ? col.render(row)
                        : String(row[col.accessor as keyof T] ?? "")}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{ textAlign: "center", padding: "1rem" }}
                >
                  No data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination-wrapper">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
    </>
  );
}

export default ReusableTable;
